const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/currency/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { Spinner } from '@tempo-io/sui-spinner';
import z from 'zod';
import i18n from '@/common/translations/i18n';
import { getOrganizationCurrencyQueryOptions } from '@/features/settings/organization-currency/queries/useOrganizationCurrencyQuery';
const paramSchema = z.object({
  openPicker: z.boolean().optional()
});
export const Route = createFileRoute('/(app)/org/$org/settings/currency/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: paramSchema,
  loader: async ({
    context: {
      queryClient,
      organizationId
    }
  }): Promise<LoaderData> => {
    await queryClient.ensureQueryData(getOrganizationCurrencyQueryOptions(organizationId ?? ''));
    return {
      crumb: i18n.t($ => $.common.settings.currency.label)
    };
  },
  pendingComponent: () => <div className="flex items-center justify-center h-full">
      <Spinner size={32} />
    </div>,
  staticData: {
    topNav: {
      title: i18n.t($ => $.common.settings.currency.label)
    }
  }
});